
import Hello from '../components/Hello'
import Hero from '../components/Hero'
import NavOptions from '../components/NavOptions'
import Timeline from '../components/Timeline'
import Sekcja from '../components/Sekcja'

const Home = () => {
  return (
    <div>
      <Hero />
      <Hello />
      <Timeline />
      <Sekcja />
      <NavOptions />
    </div>
  )
}

export default Home
